import _ from 'lodash';
import { DateTime } from 'luxon';
import {
  DailyReportItem,
  SaveOnSiteWorkEventModal
} from 'modules/components';

import { DailyReportCardLayout } from 'modules/components/layer05';
import React, { useState } from 'react';



export type ReportSubcontractorCardProps = {
  id: string;
  workLog: {
    id: string;
    dateWorked: DateTime;
    personName: string;
    hoursWorked: string;
    description: string;
  }[];
};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: ReportSubcontractorCardProps) => {
  const [
    isVisible,
    setIsVisible
  ] = useState(false);
  return (
    <>
      {isVisible && (
        <SaveOnSiteWorkEventModal.FC
          id=''
          isVisible={isVisible}
          handleClose={() => setIsVisible(() => false)}
        />
      )}

      <DailyReportCardLayout.FC
        title='Subcontractors'
        subTitle='Subcontractors present on site.'
        actionButton={{
          text: 'Add new contractor',
          onClick: () => {
            setIsVisible(() => true);
          }
        }}
      >
        {props.workLog.map((node) => (
          <DailyReportItem.FC
            key={node.id}
            id={node.id}
            reportItemType='CONTRACTOR'
            details={{
              type: 'CONTRACTOR',
              hours: _.toNumber(node.hoursWorked),
              personName: node.personName,
              profileImg: '',
              description: node.description
            }}
          />
        ))}

      </DailyReportCardLayout.FC>
    </>
  );
};
